import React from "react";

const ResearchAreasModule = React.lazy(() => import("./ui/ResearchAreas"));

export const ResearchAreasPage = () => {
  return <ResearchAreasModule />;
};
